import { LOAD_CONFIGURATION } from 'redux/configuration/actions'

export const configuration = (state = {}, action) => {

    switch (action.type)
    {
        case LOAD_CONFIGURATION:
            return {...action.configuration}
        default:
            return state
    }

}
